// Wholesale cases and normal website items are never in the same cart (cases have their own shipping: live rates, free at $250).
// Blocks the add in both directions, offers to clear the cart, and flags an already-mixed cart. The checkout rule (cart validation
// function) is the airtight backstop; this keeps the shopper from ever reaching it. Gifts (_free_gift) never count as items.
(function () {
  if (window.__wsGuard) return;
  window.__wsGuard = true;

  var ids = {};
  ((window.WS_CASES && window.WS_CASES.ids) || []).forEach(function (i) { ids[String(i)] = 1; });
  var HANDLE = /-swedish-candy-\d+-pack$/;

  function isCaseLine(i) { return !!ids[String(i.variant_id || i.id)] || HANDLE.test(i.handle || ''); }
  function isGiftLine(i) { return !!(i.properties && i.properties._free_gift); }
  function summary(cart) {
    var c = 0, r = 0;
    (cart.items || []).forEach(function (i) { if (isGiftLine(i)) return; if (isCaseLine(i)) c++; else r++; });
    return { cases: c, retail: r };
  }

  var prev = window.fetch.bind(window);

  function parseAdd(init) {
    var b = init && init.body, items = [];
    try {
      if (typeof b === 'string') {
        if (b.trim().charAt(0) === '{') { var o = JSON.parse(b); items = o.items || (o.id ? [o] : []); }
        else { var p = new URLSearchParams(b); items = [{ id: p.get('id'), properties: { _free_gift: p.get('properties[_free_gift]') } }]; }
      } else if (typeof FormData !== 'undefined' && b instanceof FormData) {
        items = [{ id: b.get('id'), properties: { _free_gift: b.get('properties[_free_gift]') } }];
      } else if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) {
        items = [{ id: b.get('id'), properties: { _free_gift: b.get('properties[_free_gift]') } }];
      }
    } catch (e) { items = []; }
    return items;
  }

  function mark(cart) {
    var s = summary(cart);
    if (!document.body) return s;
    document.body.classList.toggle('ws-cart', s.cases > 0 && s.retail === 0);
    document.body.classList.toggle('ws-mixed', s.cases > 0 && s.retail > 0);
    return s;
  }

  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt) e.textContent = txt; return e; }

  function ask(message, clearLabel) {
    return new Promise(function (resolve) {
      var back = el('div', 'wsg'), box = el('div', 'wsg__box');
      box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-labelledby', 'wsg-h');
      var h = el('h2', 'wsg__h', 'Wholesale cases are ordered on their own'); h.id = 'wsg-h';
      var p = el('p', 'wsg__p', message);
      var row = el('div', 'wsg__row');
      var keep = el('button', 'wsg__btn wsg__btn--ghost', 'Keep my cart'); keep.type = 'button';
      var cart = el('a', 'wsg__btn wsg__btn--ghost', 'Go to cart'); cart.href = '/cart';
      var clear = el('button', 'wsg__btn', clearLabel); clear.type = 'button';
      row.appendChild(keep); row.appendChild(cart); row.appendChild(clear);
      box.appendChild(h); box.appendChild(p); box.appendChild(row); back.appendChild(box);
      document.body.appendChild(back);
      var last = document.activeElement;
      function done(v) { back.remove(); document.removeEventListener('keydown', esc); if (last && last.focus) try { last.focus(); } catch (e) {} resolve(v); }
      function esc(e) { if (e.key === 'Escape') done(false); }
      keep.addEventListener('click', function () { done(false); });
      clear.addEventListener('click', function () { done(true); });
      back.addEventListener('click', function (e) { if (e.target === back) done(false); });
      document.addEventListener('keydown', esc);
      keep.focus();
    });
  }

  function refused(message) {
    return new Response(JSON.stringify({ status: 422, message: 'Wholesale cases are ordered on their own', description: message }),
      { status: 422, headers: { 'Content-Type': 'application/json' } });
  }

  window.fetch = function (input, init) {
    var args = arguments;
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!/\/cart\/add(\.js)?(\?|$)/.test(url)) return prev.apply(window, args);
    var items = parseAdd(init);
    if (!items.length) return prev.apply(window, args);
    var inCase = false, inRetail = false, inGift = false;
    items.forEach(function (i) {
      if (ids[String(i.id)]) inCase = true;
      else if (i.properties && i.properties._free_gift) inGift = true;
      else inRetail = true;
    });
    return prev('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var s = summary(cart);
      if (inGift && !inCase && !inRetail) return s.cases > 0 ? refused('Gifts do not apply to wholesale cases.') : prev.apply(window, args);
      var conflict = (inCase && (s.retail > 0 || inRetail)) || (inRetail && s.cases > 0);
      if (!conflict) return prev.apply(window, args);
      var msg = inCase
        ? 'Your cart has other items from the website. Check out first, or clear your cart to add these cases.'
        : 'Your cart has wholesale cases. Check out first, or clear your cart to add this.';
      return ask(msg, inCase ? 'Clear cart and add cases' : 'Clear cart and add this').then(function (ok) {
        if (!ok) return refused(msg);
        return prev('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }).then(function () {
          return prev.apply(window, args).then(function (res) { setTimeout(function () { location.reload(); }, 400); return res; });
        });
      });
    }).catch(function () { return prev.apply(window, args); });
  };

  // An already-mixed cart (old cart, link, other tab): say so on the cart page and hold the checkout button until it is fixed.
  function banner(cart) {
    var old = document.querySelector('.wsg-banner'); if (old) old.remove();
    var s = mark(cart);
    var btns = document.querySelectorAll('[name="checkout"], .cart__checkout-button');
    var mixed = s.cases > 0 && s.retail > 0;
    btns.forEach(function (b) { if (mixed) { b.disabled = true; b.setAttribute('data-ws-held', '1'); } else if (b.getAttribute('data-ws-held')) { b.disabled = false; b.removeAttribute('data-ws-held'); } });
    if (!mixed || !/^\/cart/.test(location.pathname)) return;
    var host = document.getElementById('MainContent'); if (!host) return;
    var b = el('div', 'wsg-banner'); b.setAttribute('role', 'alert');
    b.appendChild(el('p', 'wsg-banner__p', 'Your cart has wholesale cases and other items. They are ordered separately so shipping is right. Remove one kind to check out.'));
    function drop(wantCases) {
      var up = {};
      cart.items.forEach(function (i) {
        if (isGiftLine(i)) { if (!wantCases) up[i.key] = 0; }   // removing the website items leaves nothing for a gift to belong to
        else if (isCaseLine(i) === wantCases) up[i.key] = 0;
      });
      prev('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: up }) })
        .then(function () { location.reload(); });
    }
    var a = el('button', 'wsg__btn', 'Remove the wholesale cases'); a.type = 'button'; a.addEventListener('click', function () { drop(true); });
    var c = el('button', 'wsg__btn wsg__btn--ghost', 'Remove the other items'); c.type = 'button'; c.addEventListener('click', function () { drop(false); });
    b.appendChild(a); b.appendChild(c);
    host.insertBefore(b, host.firstChild);
  }

  function check() { prev('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(banner).catch(function () {}); }
  function start() { check(); setTimeout(check, 1200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('pageshow', check);
  window.addEventListener('cart:synced', function (e) { if (e.detail && e.detail.cart) banner(e.detail.cart); });
})();
